import React, { useContext } from "react"
import ScrollFilterBar from "../../../../Common/Filter/ScrollFilterBar";
import FilterTextInput from "../../../../Common/Filter/FilterTextInput";
import CobraReportContext from "../../../../../Context/Violation/CobraReportContext";

const CobraReportFilter=(props)=>{

    const { 
            resetData,
            filterData
        } = useContext(CobraReportContext)



    return  <ScrollFilterBar
    onReset={resetData}
    onConfirm={filterData}
    firstScreen={{
        inputs:[
            (onSet, key, currentValues)=><FilterTextInput
            key={key}
            label="Enforcement Date From"
            type="date"
            onChange={onSet}
            name="dateFrom"
            currentValues={currentValues}
          />,

          (onSet, key, currentValues)=><FilterTextInput
            key={key}
            label="Enforcement Date To"
            type="date"
            onChange={onSet}
            name="dateTo"
            currentValues={currentValues}
            />,
        ],
        names:["dateFrom", "dateTo"]
    }}
/>

}

export default CobraReportFilter